export default {"src":"/_next/static/media/defaultProfile.70e61e54.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};